import { gql } from '@apollo/client';

export const QUICK_SWITCH_ACCOUNT = gql`
      mutation QuickSwitchAccount($username: String!, $password: String!) {
         quickSwitchAccount(username: $username, password: $password) {
            token
            user {
               id
               username
               firstName
               lastName
               roles
            }
         }
      }
   `;

export const RESET_ALL_APPLICATIONS = gql`
      mutation ResetAllApplications {
         resetAllApplications {
            id
            applicationNumber
            status
            currentStage
         }
      }
   `;

export const RESET_APPLICATION_BY_NUMBER = gql`
      mutation ResetApplicationByNumber($applicationNumber: String!) {
         resetApplicationByNumber(applicationNumber: $applicationNumber) {
            id
            applicationNumber
            status
            currentStage
         }
      }
   `;

export const UNSUBMIT_ALL_APPLICATIONS = gql`
      mutation UnsubmitAllApplications {
         unsubmitAllApplications {
            id
            applicationNumber
            status
            currentStage
         }
      }
   `;

export const QUICK_STAGE_JUMP = gql`
      mutation QuickStageJump($input: QuickStageJumpInput!) {
         quickStageJump(input: $input) {
            id
            applicationNumber
            status
            currentStage
            acceptedByTechnicalStaff
            approvedByTechnicalStaff
            acceptedByReceivingClerk
            recordedByReceivingClerk
            acceptedByPENRCENROfficer
            approvedByPENRCENROfficer
            reviewedByChief
            awaitingOOP
            OOPCreated
            hasInspectionReport
            isInspectionResultPassed
            InspectionReportsReviewedByChief
            InspectionReportsReviewedByPENRCENROfficer
            awaitingPermitCreation
            PermitCreated
            certificateSignedByPENRCENROfficer
            hasCertificate
            ApprovedInventoryRequest
            history {
               stage
               status
               timestamp
               notes
            }
         }
      }
   `;

export const DELETE_APPLICATION = gql`
      mutation DeleteApplication($applicationNumber: String!) {
         deleteApplication(applicationNumber: $applicationNumber) {
            success
            message
         }
      }
   `;

export const UPDATE_GLOBAL_DELAY = gql`
      mutation UpdateGlobalDelay($delay: Int!) {
         updateGlobalDelay(delay: $delay) {
            success
            message
            currentDelay
         }
      }
   `;

export const RESET_DATABASE = gql`
      mutation ResetDatabase {
         resetDatabase {
            success
            message
         }
      }
   `;

export const CREATE_TEST_OOP = gql`
      mutation CreateTestOOP($applicationNumber: String!) {
         createTestOOP(applicationNumber: $applicationNumber) {
            id
            billNo
            applicationNumber
            namePayee
            totalAmount
            OOPstatus
            OOPSignedByTwoSignatories
            trackingNo
         }
      }
   `;

export const QUICK_OOP_STAGE_JUMP = gql`
      mutation QuickOOPStageJump($input: QuickOOPStageJumpInput!) {
         quickOOPStageJump(input: $input) {
            success
            message
            oop {
               id
               billNo
               applicationNumber
               OOPstatus
               OOPSignedByTwoSignatories
               OOPApproved
               isManualPayment
               isOnlinePayment
               paymentProof {
                  status
               }
               officialReceipt {
                  orNumber
                  dateIssued
                  amount
                  paymentMethod
                  remarks
                  receiptImage
               }
            }
         }
      }
   `;

export const DELETE_TEST_OOP = gql`
      mutation DeleteTestOOP($oopId: ID!) {
         deleteTestOOP(oopId: $oopId) {
            success
            message
         }
      }
   `;

export const DELETE_ALL_APPLICATIONS = gql`
      mutation DeleteAllApplications {
         deleteAllApplications {
            success
            message
            count
         }
      }
   `;

export const CREATE_TEST_INSPECTION = gql`
      mutation CreateTestInspection($permitId: ID!) {
         createTestInspection(permitId: $permitId) {
            id
            permitId
            applicationNumber
            applicationType
            scheduledDate
            scheduledTime
            location
            inspectionStatus
            inspectorId
            createdAt
            updatedAt
         }
      }
   `;

export const BULK_CREATE_APPLICATIONS = gql`
      mutation BulkCreateApplications($input: BulkCreateApplicationsInput!) {
         bulkCreateApplications(input: $input) {
            success
            message
            count
            applicationNumbers
         }
      }
   `;

export const DELETE_ALL_USER_NOTIFICATIONS = gql`
   mutation DeleteAllUserNotifications {
      deleteAllUserNotifications {
         success
         message
         count
      }
   }
`;

export const DELETE_ALL_PERSONNEL_NOTIFICATIONS = gql`
   mutation DeleteAllPersonnelNotifications {
      deleteAllPersonnelNotifications {
         success
         message
         count
      }
   }
`;